const PACK_KEY_BASE = "graeter_flavor_pack"; // localStorage key prefix
function notifyThemeOfCartUpdate(cartData) {
  const countSelectors = [".header__cart-count"];
  countSelectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach((el) => {
      el.textContent = cartData.item_count;
    });
  });
  document.dispatchEvent(
    new CustomEvent("cart:updated", {
      bubbles: true,
      detail: {
        cart: cartData,
      },
    })
  );
  document.dispatchEvent(
    new CustomEvent("theme:cart:updated", {
      bubbles: true,
      detail: {
        cart: cartData,
      },
    })
  );
  let announcer = document.getElementById("cart-update-announcer");
  if (!announcer) {
    announcer = document.createElement("div");
    announcer.id = "cart-update-announcer";
    announcer.setAttribute("aria-live", "polite");
    announcer.setAttribute("aria-atomic", "true");
    announcer.classList.add("visually-hidden");
    document.body.appendChild(announcer);
  }
  setTimeout(() => {
    announcer.textContent = `Cart updated. ${cartData.item_count} items.`;
  }, 100);
}
function dispatchEvent(customEvent) {
  document.documentElement.dispatchEvent(customEvent);
}
function dispatchVariantAddedEvent(bundleData) {
  dispatchEvent(
    new CustomEvent("variant:added", {
      bubbles: true,
      detail: {
        variant: bundleData.hasOwnProperty("items")
          ? bundleData.items[0]
          : bundleData
      },
    })
  );
}
function dispatchCartRefreshEvent(cartContent) {
  dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart: cartContent,
        openMiniCart: true,
      },
    })
  );
}
async function fetchCart() {
  let cartResponse = null;
  try {
    cartResponse = await fetch("/cart.js");
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
  return cartResponse;
}
class GA4FlavorPickerTracker {
  constructor(flavorPicker) {
    this.picker = flavorPicker;
    this.sessionStartTime = Date.now();
    this.interactionCount = 0;
  }

  track(eventName, parameters = {}) {
    this.interactionCount++;
    
    const enrichedParams = {
      ...parameters,
      picker_type: this.picker.isBlockVersion ? 'block' : 'full_page',
      collection_id: this.picker.collectionId || 'unknown',
      collection_handle: this.picker.elements.container?.dataset.collectionHandle || 'unknown',
      session_duration: Math.round((Date.now() - this.sessionStartTime) / 1000),
      interaction_count: this.interactionCount,
      timestamp: new Date().toISOString()
    };

    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, enrichedParams);
    }
    
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        event: eventName,
        ...enrichedParams
      });
    }

    // Debug logging
      // console.log('🍦 GA4 Event:', eventName, enrichedParams);
  }
}


class FlavorPicker {
constructor(containerSelector = ".flavor-picker-container") {
    this.pack = { activeSize: null, items: [], sizes: [] };
    this.elements = {};
    this.standardPackVariantIds = {};
    this.giftPackVariantIds = {};
    this.giftPackPrices = {};
    this.packSizes = [];
    this.packPrices = {};
    this.itemNames = {};
    this.pintIconSvg = "";
    this.selectedGiftOption = "none";
    this.giftSku = "";
    this.giftVariantId = "";
    this.shippingPackageSkuNexus = "";
    this.packageId = "";
    this.activeFilter = "all";
    this.lastViewportWidth = window.innerWidth;
    this.isMobileAccordionExpanded = false;
    this.containerSelector = containerSelector;
    this.isBlockVersion = containerSelector === ".flavor-picker-block";
    this.collectionId = "";
    this.packUpgrades = {};
    
    // Initialize GA4 tracker
    this.ga4Tracker = new GA4FlavorPickerTracker(this);
    
    this.addPackToCart = this.addPackToCart.bind(this);
    this.updateItemQuantity = this.updateItemQuantity.bind(this);
    this.setActiveSize = this.setActiveSize.bind(this);
    this.removeOneItemById = this.removeOneItemById.bind(this);
    this.openFlavorModal = this.openFlavorModal.bind(this);
    this.handleAddToPackFromModal = this.handleAddToPackFromModal.bind(this);
    this.toggleFilterDropdown = this.toggleFilterDropdown.bind(this);
    this.selectFilterOption = this.selectFilterOption.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.handleClickOutsideFilter = this.handleClickOutsideFilter.bind(this);
    
    // Global instance for integration
    if (this.isBlockVersion) {
      window.flavorPickerBlockInstance = this;
    } else {
      window.flavorPickerInstance = this;
    }
    
    this.init();
  }
  init() {
    this.cacheElements();
    if (!this.elements.container) return;
    this.collectionId = this.elements.container.dataset.collectionId || "";

    this.packageId = this.elements.container.dataset.packageId || "";
    this.shippingPackageSkuNexus =
      this.elements.container.dataset.shippingPackageSkunexus || "";
    this.pintIconSvg =
      this.elements.container.dataset.pintIcon ||
      `<svg class="gt-icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 56.44 70.9">
            <g id="Layer_2-2" data-name="Layer 2"><path fill="currentColor" d="M28.22,0C12.63,0,0,2.05,0,4.59v9.24c0,.55.33,1.04.83,1.26l3.01,1.28c.47.2.79.65.83,1.16l2.96,44.18c.1,3.05,9.22,9.19,20.59,9.19s20.51-5.76,20.59-9.19l2.96-44.18c.04-.51.36-.96.83-1.16l3.01-1.28c.5-.21.83-.71.83-1.26V4.59c0-2.53-12.63-4.59-28.22-4.59Z"></path></g>
        </svg>`;

    this.createScreenReaderAnnouncer();
    this.extractPackInformation();
    if (this.packSizes.length === 0) {
      this.showError(
        "Configuration Error: Could not find valid pack size variants. Please check the product variants."
      );
      return;
    }
    this.loadPack();
    this.setupSizeButtons();
    this.setupEventListeners();
    this.updateActiveSizeUI(this.pack.activeSize);
    this.updateFlavorItemQuantities();
    if (!this.isBlockVersion && this.elements.filterButton) {
      // ?filter=sorbets opens on that filter (links from other pages), so every filter stays on the one CYOP URL
      const urlFilter = new URLSearchParams(window.location.search).get("filter");
      const urlOption = urlFilter
        ? [...(this.elements.filterOptions || [])].find((opt) => opt.dataset.filter === urlFilter.toLowerCase())
        : null;
      if (urlOption) {
        this.elements.filterOptions.forEach((opt) => {
          opt.setAttribute("aria-selected", opt === urlOption ? "true" : "false");
          opt.setAttribute("tabindex", opt === urlOption ? "0" : "-1");
        });
      }
      if (urlFilter) {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete("filter");
        window.history.replaceState({}, "", cleanUrl.toString());
      }
      const selectedOption = this.elements.filterOptionsList?.querySelector('[aria-selected="true"]');
      if (selectedOption) {
        this.activeFilter = selectedOption.dataset.filter || "all";
        if (this.elements.filterButtonText) {
          this.elements.filterButtonText.textContent = selectedOption.textContent.trim();
        }
      }
      this.applyFilter();
    }
    this.validatePack();
    if (!this.isBlockVersion) {
      this.setupMobileView();
    }
    
    // Track picker initialization
    this.ga4Tracker.track('flavor_picker_loaded', {
      pack_sizes_available: this.packSizes,
      initial_pack_size: this.pack.activeSize,
      total_flavors_available: this.elements.flavorItems?.length || 0,
      has_gift_options: !!this.elements.giftOptions?.length
    });
    
    document.dispatchEvent(new CustomEvent("flavor-picker:loaded"));
  }
  createScreenReaderAnnouncer() {
    if (!document.getElementById("flavor-picker-announcer")) {
      const announcer = document.createElement("div");
      announcer.id = "flavor-picker-announcer";
      announcer.setAttribute("role", "status");
      announcer.setAttribute("aria-live", "polite");
      announcer.setAttribute("aria-atomic", "true");
      announcer.className = "visually-hidden";
      document.body.appendChild(announcer);
    }
  }
  announceToScreenReader(message) {
    const announcer = document.getElementById("flavor-picker-announcer");
    if (announcer) {
      announcer.textContent = "";
      setTimeout(() => {
        announcer.textContent = message;
      }, 100);
    }
  }
  toggleElementVisibility(element, visible, ariaHidden = true) {
    if (!element) return;
    element.style.display = visible ? "block" : "none";
    if (ariaHidden) {
      element.setAttribute("aria-hidden", visible ? "false" : "true");
    }
  }

  getStorageKey() {
    const collectionPart = this.collectionId
      ? `_${this.collectionId}`
      : "_default";
    return `${PACK_KEY_BASE}${collectionPart}`;
  }
  tryParseJSON(jsonString, defaultValue) {
    let parsed = defaultValue;

    if (jsonString) {
      try {
        parsed = JSON.parse(jsonString);
      } catch (error) {
        console.error('Failed to process JSON string: ', error);
      }
    }

    return parsed;
  }
  extractPackInformation() {
    const giftVariantsJson = this.elements.container.dataset.packProductGiftVariants;
    const giftVariants = this.tryParseJSON(giftVariantsJson, []);
    const packUpgradesJson = this.elements.container.dataset.packUpgrades;
    const packUpgrades = this.tryParseJSON(packUpgradesJson, {});
    const standardVariantsJson = this.elements.container.dataset.packProductVariants;
    const standardVariants = this.tryParseJSON(standardVariantsJson, []);

    this.packUpgrades = packUpgrades;
    
    this.processVariants(
      standardVariants,
      this.standardPackVariantIds,
      this.packPrices,
      this.itemNames
    );

    this.processVariants(
      giftVariants,
      this.giftPackVariantIds,
      this.giftPackPrices,
      this.itemNames
    );

    if (Object.keys(this.standardPackVariantIds).length > 0) {
      this.packSizes = Object.keys(this.standardPackVariantIds)
        .map((size) => parseInt(size, 10))
        .sort((a, b) => a - b);

      if (this.packSizes.length > 0) {
        this.pack.sizes = this.packSizes;
        this.pack.activeSize = Math.min(...this.packSizes);
      }
    }
  }
  processVariants(variants, variantIdsMap, pricesMap, itemNames) {
    if (!Array.isArray(variants) || variants.length === 0) return;
    variants.forEach((variant) => {
      const optionTexts = [
        variant.title,
        variant.option1,
        variant.option2,
        variant.option3,
      ]
        .filter((value) => !!value)
        .map((value) => value.replace(/[^0-9]/g, ""));
      const itemTexts = [
        variant.title,
        variant.option1,
        variant.option2,
        variant.option3,
      ]
        .filter((value) => !!value)
        .map((value) => value.replace(/[^A-Za-z]/g, ""));

      if (optionTexts.length > 0) {
        const size = parseInt(optionTexts[1], 10);
        if (!isNaN(size) && size > 0) {
          variantIdsMap[size] = variant.id;
          itemNames[size] = itemTexts[0] || "pint";
          if (pricesMap && typeof pricesMap === "object") {
            pricesMap[size] = variant.price;
          }
        }
      }
    });
  }
  cacheElements() {
    const container = document.querySelector(this.containerSelector);
    if (!container) return;
    this.elements = {
      container: container,
      flavorItems: container.querySelectorAll(
        ".flavor-item, .flavor-item-block"
      ),
      packSizeButtons: container.querySelectorAll(".pack-size"),
      packSlots: container.querySelector(".pack-slots"),
      addToCartBtn: container.querySelector(".add-to-cart-btn"),
      totalPrice: container.querySelector(
        '.totals span[aria-labelledby="total-label"]'
      ),
      errorMessage: container.querySelector(".flavor-picker-error"),
      filterButton: container.querySelector("#flavor-filter-dropdown-button"),
      filterOptionsList: container.querySelector("#flavor-filter-options"),
      filterOptions: container.querySelectorAll(
        '#flavor-filter-options li[role="option"]'
      ),
      filterButtonText: container.querySelector(".flavor-filter-dropdown-text"),
      giftOptions: container.querySelectorAll(".gift-option"),
      noResultsMessage: container.querySelector(".flavor-picker-no-results"),
      flavorsSection: container.querySelector(".flavor-picker-flavors"),
    };
  }
  showError(message) {
    if (this.elements.errorMessage) {
      this.elements.errorMessage.textContent = message;
      this.elements.errorMessage.style.display = "block";
    }
    if (this.elements.container) {
      this.elements.container.style.opacity = "0.7";
      this.elements.container.style.pointerEvents = "none";
    }
    console.error("Flavor Picker Error:", message);
  }
  loadPack() {
    if (window.packManager && window.packManager.state) {
      const packManagerState = window.packManager.state;

      if (
        packManagerState.collectionId &&
        String(packManagerState.collectionId) !== String(this.collectionId)
      ) {
        return;
      }

      if (packManagerState.items && packManagerState.items.length > 0) {
        this.syncWithPackManager(packManagerState);
        return;
      }
    }

    const storageKey = this.getStorageKey();
    const savedPack = localStorage.getItem(storageKey);
    if (savedPack) {
      try {
        const parsed = JSON.parse(savedPack);
        if (
          parsed.collectionId &&
          String(parsed.collectionId) !== String(this.collectionId)
        ) {
          console.warn(
            `Saved pack belongs to different collection ${parsed.collectionId}, current is ${this.collectionId}`
          );
          return;
        }
        const activeSize = this.pack.sizes.includes(parsed.activeSize)
          ? parsed.activeSize
          : this.pack.activeSize;
        const items = Array.isArray(parsed.items)
          ? parsed.items.filter(
              (item) =>
                item.id &&
                item.title &&
                typeof item.quantity === "number" &&
                item.quantity > 0
            )
          : [];
        this.pack.activeSize = activeSize;
        this.pack.items = items;
        this.adjustSizeBasedOnQuantity();
      } catch (e) {
        console.warn(
          `Failed to load/parse saved pack data for collection ${this.collectionId}. Resetting.`,
          e
        );
        localStorage.removeItem(storageKey);
      }
    }
  }
  savePack() {
    const storageKey = this.getStorageKey();
    try {
      const packWithCollectionInfo = {
        ...this.pack,
        collectionId: this.collectionId,
        collectionHandle:
          this.elements.container.dataset.collectionHandle || "default",
      };
      localStorage.setItem(storageKey, JSON.stringify(packWithCollectionInfo));

      if (window.packManager && window.packManager.isFlavorPickerActive) {
        window.packManager.state = {
          ...window.packManager.state,
          ...packWithCollectionInfo,
        };
        window.packManager.saveState();
      }

      document.dispatchEvent(
        new CustomEvent("pack:updated", {
          detail: { pack: packWithCollectionInfo },
        })
      );
    } catch (e) {
      console.error(
        `Could not save pack to localStorage with key ${storageKey}:`,
        e
      );
    }
  }
  resetPack() {
    const previousItemCount = this.getTotalQuantity();
    const previousItems = [...this.pack.items];
    
    this.pack.items = [];
    this.clearGiftOption();
    const storageKey = this.getStorageKey();
    localStorage.removeItem(storageKey);

    if (window.packManager) {
      window.packManager.clearPack();
    }

    this.updateActiveSizeUI(this.pack.activeSize);
    this.updateFlavorItemQuantities();
    this.validatePack();

    // Track pack reset
    this.ga4Tracker.track('pack_cleared', {
      items_cleared: previousItemCount,
      flavors_cleared: previousItems.map(item => ({
        id: item.id,
        name: item.title,
        quantity: item.quantity
      }))
    });

    this.announceToScreenReader("Pack cleared. All items removed.");
  }
  clearGiftOption() {
    const giftOptions =
      this.elements.container.querySelectorAll(".gift-option");
    giftOptions.forEach((opt) => {
      opt.setAttribute("aria-checked", "false");
    });
    this.selectedGiftOption = "none";
    this.giftPrice = 0;
    this.giftSku = "";
    this.giftVariantId = "";
    this.updatePrice();
    this.validatePack();
  }
  setActiveSize(size) {
    const newSize = parseInt(size, 10);
    if (this.packSizes.includes(newSize) && this.pack.activeSize !== newSize) {
      const previousSize = this.pack.activeSize;
      this.pack.activeSize = newSize;
      this.updateActiveSizeUI(newSize);
      this.validatePack();
      this.savePack();
      this.updateMobileHeaderText();
      
      // Track pack size change
      this.ga4Tracker.track('pack_size_changed', {
        previous_size: previousSize,
        new_size: newSize,
        price: this.packPrices[newSize] / 100,
        currency: 'USD',
        current_items_count: this.getTotalQuantity()
      });
      
      this.announceToScreenReader(
        `Pack size changed from ${previousSize} to ${newSize} items`
      );
    }
  }
  adjustSizeBasedOnQuantity() {
    const totalQuantity = this.getTotalQuantity();
    if (this.packSizes.includes(totalQuantity)) {
      if (this.pack.activeSize !== totalQuantity) {
        this.setActiveSize(totalQuantity);
      }
      return;
    }
    let bestFitSize = null;
    for (const size of this.packSizes) {
      if (totalQuantity <= size) {
        bestFitSize = size;
        break;
      }
    }
    if (
      bestFitSize &&
      bestFitSize < this.pack.activeSize &&
      totalQuantity <= this.pack.activeSize
    ) {
      return;
    }
    if (bestFitSize && bestFitSize !== this.pack.activeSize) {
      this.setActiveSize(bestFitSize);
    }
  }
  updateActiveSizeUI(size) {
    if (!this.elements.packSizeButtons) return;
    this.elements.packSizeButtons.forEach((button) => {
      const buttonSize = parseInt(button.dataset.size, 10);
      const isActive = buttonSize === size;
      button.classList.toggle("active", isActive);
      button.setAttribute("aria-checked", isActive ? "true" : "false");
    });
    this.updatePrice();
  }
  updatePrice() {
    if (!this.elements.totalPrice) return;
    const currentSize = this.pack.activeSize;
    const priceInCents = this.packPrices[currentSize] || 0;
    const giftPriceInCents = this.giftPrice || 0;
    const subtotalInCents = priceInCents + giftPriceInCents;
    this.elements.totalPrice.textContent = `$${(subtotalInCents / 100).toFixed(
      2
    )}`;
    this.updatePackSizeButtonPrices();
  }
  updatePackSizeButtonPrices() {
    if (!this.elements.packSizeButtons) return;
    this.elements.packSizeButtons.forEach((button) => {
      const size = parseInt(button.dataset.size, 10);
      const priceElement = button.querySelector(".pack-size-price");
      if (priceElement && this.packPrices[size] !== undefined) {
        priceElement.textContent = `$${(this.packPrices[size] / 100).toFixed(
          2
        )}`;
      }
    });
  }
  updateItemQuantity(itemElement, delta) {
    const productId = itemElement.dataset.productId;
    if (!productId) return;
    const packOutOrder = Number(itemElement.dataset.packOutOrder);
    const sku = itemElement.dataset.sku || "Unknown SKU";
    const productTitle = itemElement.dataset.productTitle || "Unknown Flavor";
    const currentTotalQuantity = this.getTotalQuantity();
    const maxPackSize = Math.max(...this.pack.sizes);
    const existingItemIndex = this.pack.items.findIndex(
      (i) => i.id === productId
    );
    let currentItemQuantity =
      existingItemIndex >= 0 ? this.pack.items[existingItemIndex].quantity : 0;
    const newItemQuantity = currentItemQuantity + delta;
    
    if (delta > 0 && currentTotalQuantity >= maxPackSize) {
      this.announceToScreenReader(
        `Pack is full. Cannot add more items. Maximum ${maxPackSize} items allowed.`
      );
      
      // Track pack full attempt
      this.ga4Tracker.track('pack_full_add_attempt', {
        flavor_name: productTitle,
        current_pack_size: this.pack.activeSize,
        current_quantity: currentTotalQuantity
      });
      
      return;
    }
    
    if (newItemQuantity < 0) return;
    
    let itemChanged = false;
    
    const imageElements = itemElement.querySelectorAll(".flavor-image");
    const imageUrl = imageElements[0] ? imageElements[0].src : "";
    const imageUrlLifestyle = imageElements[1] ? imageElements[1].src : "";
    
    if (existingItemIndex >= 0) {
      if (newItemQuantity === 0) {
        this.pack.items.splice(existingItemIndex, 1);
        itemChanged = true;
      } else {
        this.pack.items[existingItemIndex].quantity = newItemQuantity;
        if (!this.pack.items[existingItemIndex].imageUrl && imageUrl) {
          this.pack.items[existingItemIndex].imageUrl = imageUrl;
        }
        if (!this.pack.items[existingItemIndex].imageUrlLifestyle && imageUrlLifestyle) {
          this.pack.items[existingItemIndex].imageUrlLifestyle = imageUrlLifestyle;
        }
        itemChanged = true;
      }
    } else if (delta > 0) {
      this.pack.items.push({
        id: productId,
        imageUrl,
        imageUrlLifestyle,
        packOutOrderSkuNexus: packOutOrder,
        quantity: 1,
        sku,
        title: productTitle,
      });
      itemChanged = true;
    }
    
    if (itemChanged) {
      this.adjustSizeBasedOnQuantity();
      this.savePack();
      this.updateFlavorItemQuantities();
      this.validatePack();

      // Track flavor quantity change
      const eventName = delta > 0 ? 'flavor_added' : 'flavor_removed';
      this.ga4Tracker.track(eventName, {
        flavor_id: productId,
        flavor_name: productTitle,
        quantity_change: Math.abs(delta),
        new_quantity: newItemQuantity,
        total_pack_quantity: this.getTotalQuantity(),
        pack_completion_percentage: Math.round((this.getTotalQuantity() / this.pack.activeSize) * 100)
      });

      if (delta > 0) {
        this.announceToScreenReader(
          `Added ${Math.abs(
            delta
          )} ${productTitle} to pack. ${this.getTotalQuantity()} of ${
            this.pack.activeSize
          } items in pack.`
        );
      } else {
        this.announceToScreenReader(
          `Removed ${Math.abs(
            delta
          )} ${productTitle} from pack. ${this.getTotalQuantity()} of ${
            this.pack.activeSize
          } items in pack.`
        );
      }
    }
  }
  updateFlavorItemQuantities() {
    if (!this.elements.flavorItems) return;
    this.elements.flavorItems.forEach((itemElement) => {
      const productId = itemElement.dataset.productId;
      const productTitle = itemElement.dataset.productTitle || "Flavor";
      const quantityElement = itemElement.querySelector(".quantity-value");
      const decreaseBtn = itemElement.querySelector(".decrease-qty");
      const increaseBtn = itemElement.querySelector(".increase-qty");
      const packItem = this.pack.items.find((i) => i.id === productId);
      const quantity = packItem ? packItem.quantity : 0;

      if (quantityElement) {
        quantityElement.textContent = String(quantity);
        quantityElement.setAttribute(
          "aria-label",
          `${quantity} ${productTitle} in pack`
        );
      }

      if (decreaseBtn) {
        decreaseBtn.disabled = quantity <= 0;
        decreaseBtn.setAttribute(
          "aria-label",
          `Remove one ${productTitle} from pack. Currently ${quantity} in pack`
        );
      }

      if (increaseBtn) {
        const totalQuantity = this.getTotalQuantity();
        const maxSize = Math.max(...this.pack.sizes);
        const canAdd = totalQuantity < maxSize;
        increaseBtn.setAttribute(
          "aria-label",
          `Add one ${productTitle} to pack. Currently ${quantity} in pack`
        );
        if (!canAdd) {
          increaseBtn.setAttribute(
            "aria-label",
            `Cannot add ${productTitle}. Pack is full with ${totalQuantity} of ${maxSize} items`
          );
        }
      }
    });
  }
  getTotalQuantity() {
    return this.pack.items.reduce((sum, item) => sum + item.quantity, 0);
  }
  validatePack() {
    if (
      !this.elements.addToCartBtn
    )
      return;
    if (this.packSizes.length === 0) {
      this.elements.addToCartBtn.disabled = true;
      this.elements.addToCartBtn.textContent = "Setup Error";
      if (this.elements.totalPrice)
        this.elements.totalPrice.textContent = "$--.--";
      this.renderPackSlots(0, 0);
      return;
    }
    const totalQuantity = this.getTotalQuantity();
    const currentSize = this.pack.activeSize;
    const maxPackSize = Math.max(...this.packSizes);

    this.renderPackSlots(currentSize, totalQuantity);
    let buttonText = "";
    let buttonDisabled = true;
    const itemName = this.itemNames[currentSize];

    if (totalQuantity === 0) {
      buttonText = `Add ${currentSize} ${currentSize === 1 ? "item" : `items`}`;
    } else if (totalQuantity < currentSize) {
      const needed = currentSize - totalQuantity;
      buttonText = `Add ${needed} more ${needed === 1 ? "item" : `items`}`;
    } else if (totalQuantity === currentSize) {
      buttonText = "Add Pack to Cart";
      buttonDisabled = false;
    } else {
      const nextSize = this.packSizes.find((size) => size > currentSize);
      if (nextSize && totalQuantity <= nextSize) {
        buttonText = `Select ${nextSize}-${itemName}`;
      } else if (totalQuantity > maxPackSize) {
        const over = totalQuantity - maxPackSize;
        buttonText = `Remove ${itemName}s`;
      } else {
        buttonText = `Adjust Quantity`;
      }
      buttonDisabled = true;
    }
    if (window.innerWidth <= 990) {
      this.updatePackHeaderContent();
    }
    this.elements.addToCartBtn.textContent = buttonText;
    this.elements.addToCartBtn.disabled = buttonDisabled;
    this.updatePrice();
    if (window.innerWidth <= 990 && !this.isBlockVersion) {
      this.updateDrawerViewBasedOnPackState();
    }
  }
  renderPackSlots(size, filledCount) {
    if (!this.elements.packSlots) return;
    if (this.isBlockVersion) {
      const packVisualization = this.elements.packSlots.closest(
        ".pack-visualization-block"
      );
      if (packVisualization) {
        packVisualization.setAttribute("data-active-size", size);
      }
    }
    this.elements.packSlots.innerHTML = "";
    this.elements.packSlots.setAttribute(
      "aria-label",
      `Pack slots: ${filledCount} of ${size} filled`
    );
    for (let i = 0; i < size; i++) {
      const slot = document.createElement("button");
      slot.type = "button";
      slot.className = "pack-slot";
      slot.role = "button";
      const slotContainer = document.createElement("div");
      slotContainer.className = "slot-container";
      slotContainer.innerHTML = this.pintIconSvg;
      if (i < filledCount) {
        slot.classList.add("filled");
        const flavorInfo = this.getFlavorForSlot(i);
        if (flavorInfo) {
          slot.setAttribute(
            "aria-label",
            `Slot ${i + 1} of ${size}: ${
              flavorInfo.title
            }. Click to remove one.`
          );
          slot.setAttribute("title", `Remove 1 ${flavorInfo.title}`);
          const overlay = document.createElement("div");
          overlay.className = "slot-overlay";
          overlay.setAttribute("aria-hidden", "true");
          overlay.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="white"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>`;
          if (flavorInfo.imageUrl) {
            const imageOverlay = document.createElement("div");
            imageOverlay.className = "flavor-image-overlay";
            imageOverlay.style.backgroundImage = `url('${flavorInfo.imageUrl}')`;
            slotContainer.appendChild(imageOverlay);
          }
          slotContainer.appendChild(overlay);
          slot.addEventListener("click", () =>
            this.removeOneItemById(flavorInfo.id)
          );
        } else {
          slot.setAttribute("aria-label", `Slot ${i + 1}: Filled (Error)`);
          slot.disabled = true;
        }
      } else {
        slot.setAttribute("aria-label", `Slot ${i + 1} of ${size}: Empty`);
        slot.disabled = true;
      }
      slot.appendChild(slotContainer);
      this.elements.packSlots.appendChild(slot);
    }
  }
  getFlavorForSlot(slotIndex) {
    let currentIndex = 0;
    for (const item of this.pack.items) {
      if (slotIndex < currentIndex + item.quantity) {
        return {
          id: item.id,
          title: item.title,
          imageUrl: item.imageUrl || "",
        };
      }
      currentIndex += item.quantity;
    }
    console.warn(`Could not find flavor for filled slot index: ${slotIndex}`);
    return null;
  }
  removeOneItemById(productId) {
    const itemElement = this.elements.container.querySelector(
      `.flavor-item[data-product-id="${productId}"], .flavor-item-block[data-product-id="${productId}"]`
    );
    
    // Track slot removal
    const item = this.pack.items.find(i => i.id === productId);
    if (item) {
      this.ga4Tracker.track('flavor_removed_from_slot', {
        flavor_id: productId,
        flavor_name: item.title,
        removal_method: 'slot_click'
      });
    }
    
    if (itemElement) {
      this.updateItemQuantity(itemElement, -1);
    } else {
      console.warn(
        `Could not find flavor item element for ID ${productId} to remove.`
      );
      const itemIndex = this.pack.items.findIndex((i) => i.id === productId);
      if (itemIndex >= 0) {
        if (this.pack.items[itemIndex].quantity > 1)
          this.pack.items[itemIndex].quantity -= 1;
        else this.pack.items.splice(itemIndex, 1);
        this.adjustSizeBasedOnQuantity();
        this.savePack();
        this.updateFlavorItemQuantities();
        this.validatePack();
      }
    }
  }
  openFlavorModal(flavorItem) {
    if (!window.showFlavorDetailsModal) return;
    
    const id = flavorItem.dataset.judgeProductId;
    const judge = flavorItem.dataset.judge;
    const judgeReviewWidgetData = flavorItem.dataset.judgeReviewWidgetData;

    const productId = flavorItem.dataset.productId;
    const title = flavorItem.dataset.productTitle || "Flavor";
    const imageElements = flavorItem.querySelectorAll(".flavor-image");
    const imageUrl = imageElements[0] ? imageElements[0].src : "";
    const imageUrlLifestyle = imageElements[1] ? imageElements[1].src : "";
    const handle = flavorItem.dataset.productHandle;
    
    // Track modal open
    this.ga4Tracker.track('flavor_modal_opened', {
      flavor_id: productId,
      flavor_name: title,
      flavor_handle: handle,
      current_quantity: this.getItemQuantityById(productId)
    });
    
    window.showFlavorDetailsModal(id, judge, judgeReviewWidgetData, productId, title, imageUrl, imageUrlLifestyle, null, handle);
  }
  handleAddToPackFromModal(eventDetail) {
    if (!eventDetail || !eventDetail.id) return;
    const { id, title, quantity, imageUrl, imageUrlLifestyle, packOutOrderSkuNexus, sku } = eventDetail;
    const itemElement = this.elements.container.querySelector(
      `.flavor-item[data-product-id="${id}"], .flavor-item-block[data-product-id="${id}"]`
    );
    if (!itemElement) {
      console.warn(
        `Could not find flavor item element for ID ${id} from modal update.`
      );
      const itemIndex = this.pack.items.findIndex((i) => i.id === id);
      if (itemIndex >= 0) {
        if (quantity <= 0) this.pack.items.splice(itemIndex, 1);
        else {
          this.pack.items[itemIndex].quantity = quantity;
          if (imageUrl) this.pack.items[itemIndex].imageUrl = imageUrl;
          if (imageUrlLifestyle) this.pack.items[itemIndex].imageUrlLifestyle = imageUrlLifestyle;
        }
      } else if (quantity > 0) {
        this.pack.items.push({
          id,
          imageUrl: imageUrl || "",
          imageUrlLifestyle: imageUrlLifestyle || "",
          packOutOrderSkuNexus,
          quantity,
          sku,
          title,
        });
      }
    } else {
      const currentPackQuantity = this.getItemQuantityById(id);
      const delta = quantity - currentPackQuantity;
      if (currentPackQuantity === 0 && quantity > 0) {
        const imageElements = itemElement.querySelectorAll(".flavor-image");
        const itemImageUrl = imageElements[0] ? imageElements[0].src : "";
        const itemImageUrlLifestyle = imageElements[1] ? imageElements[1].src : "";
        const itemIndex = this.pack.items.findIndex((i) => i.id === id);
        if (itemIndex >= 0 && itemImageUrl) {
          this.pack.items[itemIndex].imageUrl = itemImageUrl;
        }
        if (itemIndex >= 0 && itemImageUrlLifestyle) {
          this.pack.items[itemIndex].imageUrlLifestyle = itemImageUrlLifestyle;
        }
      }
      if (delta !== 0) {
        const direction = delta > 0 ? 1 : -1;
        for (let i = 0; i < Math.abs(delta); i++) {
          this.updateItemQuantity(itemElement, direction);
        }
      }
    }
    if (!itemElement) {
      this.adjustSizeBasedOnQuantity();
      this.savePack();
      this.updateFlavorItemQuantities();
      this.validatePack();
    }
  }
  getItemQuantityById(productId) {
    const item = this.pack.items.find(
      (i) => String(i.id) === String(productId)
    );
    return item ? item.quantity : 0;
  }
  syncWithPackManager(packState) {
    if (!packState || !packState.items) return;

    if (
      packState.collectionId &&
      String(packState.collectionId) !== String(this.collectionId)
    ) {
      return;
    }

    this.pack.items = [];

    packState.items.forEach((packItem) => {
      this.pack.items.push({
        id: packItem.id,
        imageUrl: packItem.imageUrl || "",
        imageUrlLifestyle: packItem.imageUrlLifestyle || "",
        packOutOrderSkuNexus: packItem.packOutOrderSkuNexus,
        quantity: packItem.quantity,
        sku: packItem.sku,
        title: packItem.title,
      });
    });

    if (packState.activeSize) {
      this.pack.activeSize = packState.activeSize;
    }

    if (packState.sizes && packState.sizes.length > 0) {
      this.pack.sizes = packState.sizes;
    }
    const totalQuantity = this.getTotalQuantity();
    if (totalQuantity > 0 && !this.pack.activeSize) {
      const appropriateSize =
        this.packSizes.find((size) => size >= totalQuantity) ||
        this.packSizes[this.packSizes.length - 1];
      this.setActiveSize(appropriateSize);
    }
    this.pack.items.forEach((item) => {
      if (!item.imageUrl) {
        const itemElement = this.elements.container.querySelector(
          `.flavor-item[data-product-id="${item.id}"], .flavor-item-block[data-product-id="${item.id}"]`
        );
        
        if (itemElement) {
          const imageElements = itemElement.querySelectorAll(".flavor-image");

          item.imageUrl = imageElements[0] ? imageElements[0].src : "";
          item.imageUrlLifestyle = imageElements[1] ? imageElements[1].src : "";
        }
      }
    });
    this.adjustSizeBasedOnQuantity();
    this.savePack();
    this.updateFlavorItemQuantities();
    this.validatePack();
  }
  async addPackToCart() {
    const currentSize = this.pack.activeSize;
    if (this.getTotalQuantity() !== currentSize) {
      alert(
        `Your pack requires exactly ${currentSize} ${
          currentSize === 1
            ? this.itemNames[currentSize]
            : this.itemNames[currentSize]
        }s. You currently have ${this.getTotalQuantity()}.`
      );
      this.validatePack();
      return;
    }
    
    const button = this.elements.addToCartBtn;
    if (!button) {
      console.error("Add to cart button not found.");
      return;
    }
    
    button.disabled = true;
    const originalButtonText = button.textContent;
    button.textContent = "Adding...";
    
    // Track add to cart attempt
    const cartEventData = {
      pack_size: currentSize,
      total_items: this.getTotalQuantity(),
      pack_price: this.packPrices[currentSize] / 100,
      gift_option: this.selectedGiftOption,
      gift_price: this.giftPrice / 100,
      total_price: (this.packPrices[currentSize] + this.giftPrice) / 100,
      currency: 'USD',
      flavors: this.pack.items.map(item => ({
        id: item.id,
        name: item.title,
        quantity: item.quantity
      }))
    };
    
    this.ga4Tracker.track('add_to_cart_clicked', cartEventData);

    const items = this.pack.items.map((item) => ({
      imageUrl: item.imageUrl,
      imageUrlLifestyle: item.imageUrlLifestyle,
      packOutOrderSkuNexus: item.packOutOrderSkuNexus,
      productId: `gid://shopify/ProductVariant/${item.id}`,
      quantity: item.quantity,
      sku: item.sku,
      title: item.title,
    }));
    
    if (this.giftVariantId) {
      items.push({
        imageUrl: "",
        imageUrlLifestyle: "",
        packOutOrderSkuNexus: 1000000,
        price: this.giftPrice / 100,
        productId: `gid://shopify/ProductVariant/${this.giftVariantId}`,
        sku: this.giftSku,
        title: "Gift Packaging",
        quantity: 1,
      });
    }

    const sorted = items.sort((a, b) => a.packOutOrderSkuNexus - b.packOutOrderSkuNexus);

    const packVariantId = this.standardPackVariantIds[currentSize];
    const packProperties = {
      _bundleType: "flavor_picker_pack",
      _pack: JSON.stringify({ items: sorted }),
      _packId: crypto?.randomUUID() || `${Date.now()}`,
      _packSize: String(currentSize),
      _packageId: this.packageId || 'ICECREAM',
      _productId: String(packVariantId),
      _shippingPackageSkuNexus: this.shippingPackageSkuNexus || "pint_pack",
    };

    const packUpgrade = this.packUpgrades[packVariantId];

    if (packUpgrade) {
      packProperties._upgradePackProduct = JSON.stringify(packUpgrade);
    }

    let bundleResponse = null;

    try {
      const sectionsToRequest = "mini-cart,cart-drawer";
      const sectionsUrl = window.location.pathname;
      const cartItems = [
        {
          id: packVariantId,
          quantity: 1,
          properties: packProperties,
        },
      ];
      const requestBody = {
        items: cartItems,
        sections: sectionsToRequest,
        sections_url: sectionsUrl,
      };
      
      bundleResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      
      if (bundleResponse && bundleResponse.ok) {
        // Track successful add to cart
        this.ga4Tracker.track('add_to_cart_success', {
          ...cartEventData,
          pack_id: packProperties._packId
        });
        
        // Also track as enhanced ecommerce event
        if (typeof gtag !== 'undefined') {
          gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: cartEventData.total_price,
            items: [{
              item_id: packVariantId,
              item_name: `${currentSize} Pack`,
              item_category: 'Ice Cream Pack',
              item_variant: this.selectedGiftOption !== 'none' ? 'With Gift' : 'Standard',
              price: cartEventData.total_price,
              quantity: 1
            }]
          });
        }
        
        this.resetPack();
        this.validatePack();
        const bundleData = await bundleResponse.json();
        dispatchVariantAddedEvent(bundleData);
        const cartResponse = await fetchCart();
        if (cartResponse && cartResponse.ok) {
          const cartContent = await cartResponse.json();
          const cartRefreshedContent = {
            ...cartContent,
            sections: bundleData.sections,
          };
          dispatchCartRefreshEvent(cartRefreshedContent);
          notifyThemeOfCartUpdate(cartContent);
        } else {
          console.error("Failed to fetch updated cart state.");
          notifyThemeOfCartUpdate({
            item_count: (
              await fetch("/cart.js")
                .then((r) => r.json())
                .catch(() => ({
                  item_count: "?",
                }))
            ).item_count,
          });
        }
      } else {
        const errorData = bundleResponse
          ? await bundleResponse.json()
          : {
              message: "Network error",
            };
        console.error("Error adding pack to cart:", errorData);
        
        // Track add to cart failure
        this.ga4Tracker.track('add_to_cart_failed', {
          ...cartEventData,
          error_message: errorData.description || errorData.message || 'Unknown error'
        });
        
        alert(
          `Error: ${
            errorData.description ||
            errorData.message ||
            "Could not add pack to cart."
          }`
        );
        button.textContent = originalButtonText;
        button.disabled = false;
      }
    } catch (error) {
      console.error("Error adding pack to cart:", error);
      
      // Track add to cart error
      this.ga4Tracker.track('add_to_cart_error', {
        ...cartEventData,
        error_message: error.message
      });
      
      alert(`An error occurred: ${error.message}`);
      button.textContent = originalButtonText;
      button.disabled = false;
    } finally {
      setTimeout(() => {
        if (button && !bundleResponse?.ok) {
          button.textContent = this.elements.addToCartBtn.textContent;
          button.disabled = this.elements.addToCartBtn.disabled;
        }
        this.validatePack();
      }, 300);
    }
  }
  setupSizeButtons() {
    if (!this.elements.container || this.packSizes.length === 0) return;
    const packSizesContainer =
      this.elements.container.querySelector(".pack-sizes");
    if (!packSizesContainer) return;
    packSizesContainer.innerHTML = "";
    if (this.packSizes.length === 1) {
      packSizesContainer.classList.add("single-size-container");
    }
    this.packSizes.forEach((size) => {
      const button = document.createElement("button");
      button.type = "button";
      button.role = "radio";
      button.className = "pack-size";
      if (this.packSizes.length === 1) {
        button.classList.add("single-size");
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
      }
      button.dataset.size = size;
      const priceInCents = this.packPrices[size] || 0;
      const priceString = `$${(priceInCents / 100).toFixed(2)}`;
      button.setAttribute(
        "aria-checked",
        size === this.pack.activeSize ? "true" : "false"
      );
      if (size === this.pack.activeSize) button.classList.add("active");
      button.innerHTML = `
              <span class="pack-size-count">${size} ${this.itemNames[
        size
      ].toUpperCase()}${size === 1 ? "" : "S"}</span>
              <span class="pack-size-price">${priceString}</span>
            `;
      button.setAttribute(
        "aria-label",
        `${size} ${this.itemNames[size]} for ${priceString}${
          this.packSizes.length === 1 ? " (only option available)" : ""
        }`
      );
      if (this.packSizes.length > 1) {
        button.addEventListener("click", () => this.setActiveSize(size));
      }
      packSizesContainer.appendChild(button);
    });
    this.elements.packSizeButtons =
      packSizesContainer.querySelectorAll(".pack-size");
    const packHeader = this.elements.container.querySelector(
      ".pack-option-header"
    );
    if (packHeader && this.packSizes.length > 1) {
      const smallSize = this.packSizes[0];
      const largeSize = this.packSizes[this.packSizes.length - 1];
      const smallPriceCents = this.packPrices[smallSize] || 0;
      const largePriceCents = this.packPrices[largeSize] || 0;
      const priceDiffCents =
        largePriceCents - smallPriceCents * (largeSize / smallSize);
      const fullPriceEquivalentCents =
        smallPriceCents * (largeSize / smallSize);
      if (priceDiffCents < 0) {
        packHeader.innerHTML = `SAVE $${(
          Math.abs(priceDiffCents) / 100
        ).toFixed(2)} ON ${largeSize} ${this.itemNames[
          largeSize
        ].toUpperCase()} 
                                  <span class="sale-price">$${(
                                    largePriceCents / 100
                                  ).toFixed(2)}</span> 
                                  <span class="original-price">$${(
                                    fullPriceEquivalentCents / 100
                                  ).toFixed(2)}</span>`;
      } else {
        packHeader.innerHTML = `${largeSize} ${this.itemNames[
          largeSize
        ].toUpperCase()} <span class="sale-price">$${(
          largePriceCents / 100
        ).toFixed(2)}</span>`;
      }
    } else if (packHeader && this.packSizes.length === 1) {
      packHeader.innerHTML = "";
      packHeader.style.display = "none";
    }
    this.updateMobileHeaderText();
  }
  toggleFilterDropdown(event) {
    if (!this.elements.filterButton || !this.elements.filterOptionsList) return;
    
    const isExpanded =
      this.elements.filterButton.getAttribute("aria-expanded") === "true";
    
    this.elements.filterButton.setAttribute("aria-expanded", !isExpanded);
    this.elements.filterOptionsList.style.display = isExpanded
      ? "none"
      : "block";
    
    if (!isExpanded) {
      // Track filter dropdown open
      this.ga4Tracker.track('filter_dropdown_opened', {
        current_filter: this.activeFilter
      });
      
      document.addEventListener("click", this.handleClickOutsideFilter, true);
      this.elements.filterOptionsList.addEventListener(
        "keydown",
        this.handleFilterKeydown
      );
      setTimeout(() => {
        const firstOption = this.elements.filterOptions?.[0];
        if (firstOption) {
          firstOption.focus();
        }
      }, 50);
    } else {
      document.removeEventListener(
        "click",
        this.handleClickOutsideFilter,
        true
      );
      this.elements.filterOptionsList.removeEventListener(
        "keydown",
        this.handleFilterKeydown
      );
    }
  }
  handleClickOutsideFilter(event) {
    if (!this.elements.filterButton || !this.elements.filterOptionsList) return;
    if (
      !this.elements.filterButton.contains(event.target) &&
      !this.elements.filterOptionsList.contains(event.target)
    ) {
      this.closeFilterDropdown();
    }
  }
  handleFilterKeydown = (event) => {
    const activeOption = document.activeElement;
    const allOptions = Array.from(this.elements.filterOptions || []);
    const currentIndex = allOptions.indexOf(activeOption);

    switch (event.key) {
      case "Escape":
        event.preventDefault();
        this.closeFilterDropdown();
        this.elements.filterButton?.focus();
        break;
      case "ArrowDown":
        event.preventDefault();
        if (currentIndex < allOptions.length - 1) {
          allOptions[currentIndex + 1].focus();
        } else {
          allOptions[0].focus();
        }
        break;
      case "ArrowUp":
        event.preventDefault();
        if (currentIndex > 0) {
          allOptions[currentIndex - 1].focus();
        } else {
          allOptions[allOptions.length - 1].focus();
        }
        break;
      case "Home":
        event.preventDefault();
        allOptions[0].focus();
        break;
      case "End":
        event.preventDefault();
        allOptions[allOptions.length - 1].focus();
        break;
    }
  };
  closeFilterDropdown() {
    if (!this.elements.filterButton || !this.elements.filterOptionsList) return;
    if (this.elements.filterButton.getAttribute("aria-expanded") === "true") {
      this.elements.filterButton.setAttribute("aria-expanded", "false");
      this.elements.filterOptionsList.style.display = "none";
      document.removeEventListener(
        "click",
        this.handleClickOutsideFilter,
        true
      );
      this.elements.filterOptionsList.removeEventListener(
        "keydown",
        this.handleFilterKeydown
      );
    }
  }
selectFilterOption(event) {
    const selectedOption = event.currentTarget;
    const newFilter = selectedOption.dataset.filter;
    
    if (newFilter && this.activeFilter !== newFilter) {
      const previousFilter = this.activeFilter;
      this.activeFilter = newFilter;
      
      if (this.elements.filterButtonText) {
        this.elements.filterButtonText.textContent = selectedOption.textContent;
      }
      
      this.elements.filterOptions?.forEach((opt) => {
        opt.setAttribute(
          "aria-selected",
          opt === selectedOption ? "true" : "false"
        );
        opt.setAttribute("tabindex", opt === selectedOption ? "0" : "-1");
      });
      
      // Track filter change
      this.ga4Tracker.track('filter_applied', {
        previous_filter: previousFilter,
        new_filter: newFilter,
        filter_label: selectedOption.textContent.trim()
      });
      
      this.applyFilter();
    }
    
    this.closeFilterDropdown();
    this.elements.filterButton?.focus();
  }
  applyFilter() {
    if (
      !this.elements.flavorItems ||
      !this.elements.noResultsMessage ||
      !this.elements.flavorsSection
    )
      return;
    let visibleCount = 0;
    const filterValue = this.activeFilter;
    this.elements.flavorItems.forEach((item) => {
      let shouldShow = true;

      if (filterValue !== "all") {
        const tags = item.dataset.tags || "";
        const tagList = tags
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean);

        shouldShow = tagList.includes(filterValue);
      }

      item.style.display = shouldShow ? "" : "none";
      
      if (shouldShow) {
        visibleCount++;
      }
    });
    if (this.elements.noResultsMessage) {
      this.elements.noResultsMessage.style.display =
        visibleCount === 0 ? "block" : "none";
    }
    if (this.elements.flavorsSection) {
      this.elements.flavorsSection.classList.toggle(
        "has-results",
        visibleCount > 0
      );
      this.elements.flavorsSection.classList.toggle(
        "no-results",
        visibleCount === 0
      );
    }
  }
  setupMobileView() {
    // Skip mobile view setup for block version
    if (this.isBlockVersion) return;

    const summaryWrapper =
      this.elements.container.querySelector(".summary-wrapper");
    const packOptionHeader = this.elements.container.querySelector(
      ".pack-option-header"
    );
    const packVisualization = this.elements.container.querySelector(
      ".pack-visualization"
    );
    const giftPackaging =
      this.elements.container.querySelector(".gift-packaging");
    const totals = this.elements.container.querySelector(".totals");
    const addToCartBtn =
      this.elements.container.querySelector(".add-to-cart-btn");
    if (!summaryWrapper || !packOptionHeader) return;
    if (window.innerWidth <= 990) {
      this.isMobileAccordionExpanded = false;
      packOptionHeader.setAttribute("aria-expanded", "false");
      packOptionHeader.setAttribute("role", "button");
      packOptionHeader.setAttribute("tabindex", "0");
      packOptionHeader.setAttribute("aria-controls", "mobile-pack-content");
      summaryWrapper.classList.add("collapsed");
      summaryWrapper.setAttribute("id", "mobile-pack-content");
      this.toggleElementVisibility(packVisualization, false);
      this.toggleElementVisibility(giftPackaging, false);
    } else {
      this.isMobileAccordionExpanded = true;
      packOptionHeader.removeAttribute("role");
      packOptionHeader.removeAttribute("tabindex");
      packOptionHeader.removeAttribute("aria-controls");
    }
    this.handleLayoutChange(
      summaryWrapper,
      totals,
      addToCartBtn,
      packOptionHeader,
      packVisualization,
      giftPackaging
    );
    packOptionHeader.addEventListener("click", () => {
      if (window.innerWidth > 990) return;
      this.isMobileAccordionExpanded = !this.isMobileAccordionExpanded;
      packOptionHeader.setAttribute(
        "aria-expanded",
        this.isMobileAccordionExpanded ? "true" : "false"
      );
      if (this.isMobileAccordionExpanded) {
        summaryWrapper.classList.remove("collapsed");
        this.toggleElementVisibility(packVisualization, true);
        this.toggleElementVisibility(giftPackaging, true);
        setTimeout(() => {
          const firstButton = summaryWrapper.querySelector(
            "button:not([disabled]), a:not([disabled])"
          );
          if (firstButton) {
            firstButton.focus();
          }
        }, 100);
      } else {
        summaryWrapper.classList.add("collapsed");
        this.toggleElementVisibility(packVisualization, false);
        this.toggleElementVisibility(giftPackaging, false);
      }
      this.updatePackHeaderContent();
    });

    packOptionHeader.addEventListener("keydown", (e) => {
      if (window.innerWidth > 990) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        packOptionHeader.click();
      }
    });
    window.addEventListener("resize", () => {
      const wasMobile = this.lastViewportWidth <= 990;
      const isMobile = window.innerWidth <= 990;
      this.handleLayoutChange(
        summaryWrapper,
        totals,
        addToCartBtn,
        packOptionHeader,
        packVisualization,
        giftPackaging
      );
      if (isMobile !== wasMobile) {
        if (isMobile) {
          this.isMobileAccordionExpanded = false;
          packOptionHeader.setAttribute("aria-expanded", "false");
          summaryWrapper.classList.add("collapsed");
          this.toggleElementVisibility(packVisualization, false);
          this.toggleElementVisibility(giftPackaging, false);
        } else {
          this.isMobileAccordionExpanded = true;
          packOptionHeader.setAttribute("aria-expanded", "true");
          summaryWrapper.classList.remove("collapsed");
          this.toggleElementVisibility(packVisualization, true);
          this.toggleElementVisibility(giftPackaging, true);
          
          setTimeout(() => {
            this.updatePackHeaderContent(true);
          }, 0);
        }
      }
      this.lastViewportWidth = window.innerWidth;
    });
    this.updatePackHeaderContent();
  }
  handleLayoutChange(
    summaryWrapper,
    totals,
    addToCartBtn,
    packOptionHeader,
    packVisualization,
    giftPackaging
  ) {
    // Skip for block version
    if (this.isBlockVersion) return;

    const wasMobile = this.lastViewportWidth <= 990;
    const isMobile = window.innerWidth <= 990;
    if (isMobile) {
      this.moveTotalsToMobile(totals, addToCartBtn);
    } else {
      this.moveTotalsToDesktop(totals, addToCartBtn);
    }
    if (isMobile !== wasMobile) {
      if (isMobile) {
        this.isMobileAccordionExpanded = false;
        packOptionHeader.setAttribute("aria-expanded", "false");
        summaryWrapper.classList.add("collapsed");
        this.toggleElementVisibility(packVisualization, false);
        this.toggleElementVisibility(giftPackaging, false);

        if (!packOptionHeader.querySelector(".mobile-dropdown-arrow")) {
          const arrow = document.createElement("span");
          arrow.className = "mobile-dropdown-arrow";
          arrow.innerHTML = "▼";
          packOptionHeader.appendChild(arrow);
        }
      } else {
        summaryWrapper.classList.remove("collapsed");
        packOptionHeader.setAttribute("aria-expanded", "true");
        this.toggleElementVisibility(packVisualization, true);
        this.toggleElementVisibility(giftPackaging, true);
        
        this.updatePackHeaderContent(true);
      }
    } else if (isMobile) {
      this.updatePackHeaderContent();
    }
  }
  moveTotalsToMobile(totals, addToCartBtn) {
    if (!totals || !addToCartBtn) return;
    const flavorPickerSummary = this.elements.container.querySelector(
      ".flavor-picker-summary"
    );
    if (!flavorPickerSummary) return;
    let checkoutArea = this.elements.container.querySelector(".checkout-area");
    if (!checkoutArea) {
      checkoutArea = document.createElement("div");
      checkoutArea.className = "checkout-area";
      if (!totals.dataset.originalParent) {
        totals.dataset.originalParent = "flavor-picker-summary";
      }
      if (!addToCartBtn.dataset.originalParent) {
        addToCartBtn.dataset.originalParent = "flavor-picker-summary";
      }
      checkoutArea.appendChild(totals);
      checkoutArea.appendChild(addToCartBtn);
      flavorPickerSummary.appendChild(checkoutArea);
    }
  }
  selectGiftOption(option) {
    const giftOptions =
      this.elements.container.querySelectorAll(".gift-option");
    const isAlreadySelected = option.getAttribute("aria-checked") === "true";
    
    giftOptions.forEach((opt) => {
      opt.setAttribute("aria-checked", "false");
    });
    
    if (isAlreadySelected) {
      // Track gift option removal
      this.ga4Tracker.track('gift_option_removed', {
        gift_option: this.selectedGiftOption,
        gift_price: this.giftPrice / 100
      });
      
      this.clearGiftOption();
    } else {
      option.setAttribute("aria-checked", "true");
      this.selectedGiftOption = option.getAttribute("value");
      
      this.giftPrice = +option.dataset.giftPrice || 0;
      this.giftVariantId = option.dataset.giftId || "";
      this.giftSku = option.dataset.giftSku || "";

      // Track gift option selection
      this.ga4Tracker.track('gift_option_selected', {
        gift_option: this.selectedGiftOption,
        gift_variant_id: this.giftVariantId,
        gift_price: this.giftPrice / 100,
        currency: 'USD'
      });
    }
    
    this.updatePrice();
    this.validatePack();
  }
  moveTotalsToDesktop(totals, addToCartBtn) {
    const checkoutArea =
      this.elements.container.querySelector(".checkout-area");
    if (!checkoutArea) return;
    const flavorPickerSummary = this.elements.container.querySelector(
      ".flavor-picker-summary"
    );
    if (!flavorPickerSummary) return;
    if (checkoutArea.contains(totals)) {
      flavorPickerSummary.appendChild(totals);
    }
    if (checkoutArea.contains(addToCartBtn)) {
      flavorPickerSummary.appendChild(addToCartBtn);
    }
    checkoutArea.remove();
  }
  updatePackHeaderContent(forceDesktop = false) {
    if (this.isBlockVersion) return;
    
    const packOptionHeader = this.elements.container.querySelector(".pack-option-header");
    if (!packOptionHeader || this.packSizes.length <= 1) return;
    
    const isMobile = window.innerWidth <= 990 && !forceDesktop;
    
    if (isMobile) {
      const totalQuantity = this.getTotalQuantity();
      const currentSize = this.pack.activeSize;
      
      packOptionHeader.innerHTML = "";
      
      const headerText = this.isMobileAccordionExpanded
        ? `CLOSE PACK (${totalQuantity}/${currentSize})`
        : `VIEW PACK (${totalQuantity}/${currentSize})`;
      
      packOptionHeader.appendChild(document.createTextNode(headerText));
      
      if (!packOptionHeader.querySelector(".mobile-dropdown-arrow")) {
        const arrow = document.createElement("span");
        arrow.className = "mobile-dropdown-arrow";
        arrow.innerHTML = "▼";
        packOptionHeader.appendChild(arrow);
      }
    } else {
      const smallSize = this.packSizes[0];
      const largeSize = this.packSizes[this.packSizes.length - 1];
      const smallPriceCents = this.packPrices[smallSize] || 0;
      const largePriceCents = this.packPrices[largeSize] || 0;
      const priceDiffCents = largePriceCents - smallPriceCents * (largeSize / smallSize);
      const fullPriceEquivalentCents = smallPriceCents * (largeSize / smallSize);
      const size = this.pack.activeSize;
      
      packOptionHeader.innerHTML = "";
      
      if (priceDiffCents < 0) {
        packOptionHeader.innerHTML = `SAVE $${(
          Math.abs(priceDiffCents) / 100
        ).toFixed(2)} ON ${largeSize} ${this.itemNames[size].toUpperCase()}  
          <span class="sale-price">$${(largePriceCents / 100).toFixed(2)}</span> 
          <span class="original-price">$${(fullPriceEquivalentCents / 100).toFixed(2)}</span>`;
      } else {
        packOptionHeader.innerHTML = `SAVE $40 ON ${largeSize} ${this.itemNames[size].toUpperCase()} 
          <span class="sale-price">$${(largePriceCents / 100).toFixed(2)}</span> 
          <span class="original-price">$${((largePriceCents / 100) + 40).toFixed(2)}</span>`;
      }
    }
  }
  
  updateMobileHeaderText() {
    if (this.isBlockVersion) return;
    if (window.innerWidth > 990 || !this.elements.container) return;

    const packOptionHeader = this.elements.container.querySelector(
      ".pack-option-header"
    );
    if (!packOptionHeader) return;

    const hasPackCount = packOptionHeader.textContent.includes("PACK (");
    if (hasPackCount) {
      const totalQuantity = this.getTotalQuantity();
      const currentSize = this.pack.activeSize;

      const childNodes = Array.from(packOptionHeader.childNodes);
      childNodes.forEach((node) => {
        if (node.nodeType === 3) {
          node.remove();
        }
      });

      const headerText = this.isMobileAccordionExpanded
        ? `CLOSE PACK (${totalQuantity}/${currentSize})`
        : `VIEW PACK (${totalQuantity}/${currentSize})`;

      const textNode = document.createTextNode(headerText);
      packOptionHeader.insertBefore(textNode, packOptionHeader.firstChild);
    }

    if (!packOptionHeader.querySelector(".mobile-dropdown-arrow")) {
      const arrow = document.createElement("span");
      arrow.className = "mobile-dropdown-arrow";
      arrow.innerHTML = "▼";
      packOptionHeader.appendChild(arrow);
    }
  }
  updateDrawerViewBasedOnPackState() {
    if (window.innerWidth > 990) return;
    const summaryWrapper =
      this.elements.container.querySelector(".summary-wrapper");
    const totalQuantity = this.getTotalQuantity();
    const currentSize = this.pack.activeSize;
    if (!summaryWrapper) return;
    if (totalQuantity === currentSize) {
      summaryWrapper.classList.add("filled-view");
    } else {
      summaryWrapper.classList.remove("filled-view");
    }
  }
  setupEventListeners() {
    this.elements.packSizeButtons?.forEach((button) => {
      button.addEventListener("click", () =>
        this.setActiveSize(button.dataset.size)
      );
    });
    
    this.elements.flavorItems?.forEach((item) => {
      const increaseBtn = item.querySelector(".increase-qty");
      const decreaseBtn = item.querySelector(".decrease-qty");
      const modalTrigger = item.querySelector(".flavor-item-clickable-area");
      const imageElements = item.querySelectorAll(".flavor-image");
      const imageElement = imageElements.length > 1 ? imageElements[1] : imageElements[0];
      
      increaseBtn?.addEventListener("click", (e) => {
        e.stopPropagation();
        this.updateItemQuantity(item, 1);
      });
      
      decreaseBtn?.addEventListener("click", (e) => {
        e.stopPropagation();
        this.updateItemQuantity(item, -1);
      });
      
      modalTrigger?.addEventListener("click", (e) => {
        e.preventDefault();
        this.openFlavorModal(item);
      });
      
      if (
        imageElement &&
        imageElement.dataset.featuredImageUrl &&
        imageElement.dataset.hoverImageUrl &&
        imageElement.dataset.featuredImageUrl !==
          imageElement.dataset.hoverImageUrl
      ) {
        const firstUrl = imageElement.dataset.featuredImageUrl;
        const secondUrl = imageElement.dataset.hoverImageUrl;
        const hoverImage = new Image();
        hoverImage.src = secondUrl;
        
        modalTrigger.addEventListener("mouseenter", () => {
          imageElement.style.opacity = "0";
          setTimeout(() => {
            imageElement.src = secondUrl;
            imageElement.style.opacity = "1";
          }, 75);
        });
        
        modalTrigger.addEventListener("mouseleave", () => {
          imageElement.style.opacity = "0";
          setTimeout(() => {
            imageElement.src = firstUrl;
            imageElement.style.opacity = "1";
          }, 75);
        });
      }
    });
    
    if (!this.isBlockVersion) {
      this.elements.filterButton?.addEventListener(
        "click",
        this.toggleFilterDropdown
      );
      
      this.elements.filterOptions?.forEach((option) => {
        option.addEventListener("click", this.selectFilterOption);
        option.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            this.selectFilterOption({
              currentTarget: option,
            });
          }
        });
      });
    }
    
    this.elements.addToCartBtn?.addEventListener("click", this.addPackToCart);
    
    document.addEventListener("addToPack", (event) => {
      const detail = event.detail;
      const isForBlock = detail.source === "block";
      if (
        (isForBlock && this.isBlockVersion) ||
        (!isForBlock && !this.isBlockVersion)
      ) {
        this.handleAddToPackFromModal(detail);
      }
    });
    
    document.addEventListener("pack-manager:sync", (event) => {
      if (!this.isBlockVersion) {
        this.syncWithPackManager(event.detail.pack);
      }
    });
    
    const giftOptions =
      this.elements.container.querySelectorAll(".gift-option");
    giftOptions?.forEach((option) => {
      option.addEventListener("click", () => {
        window.showFlavorDetailsAddOnModal(option);
      });
    });
    
    // Track page visibility for engagement metrics
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.ga4Tracker.track('flavor_picker_backgrounded', {
          total_items_in_pack: this.getTotalQuantity(),
          pack_completion_percentage: Math.round((this.getTotalQuantity() / this.pack.activeSize) * 100)
        });
      } else {
        this.ga4Tracker.track('flavor_picker_resumed', {
          total_items_in_pack: this.getTotalQuantity()
        });
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".flavor-picker-container")) {
    if (!document.getElementById("cart-update-announcer")) {
      const div = document.createElement("div");
      div.id = "cart-update-announcer";
      div.setAttribute("aria-live", "polite");
      div.setAttribute("aria-atomic", "true");
      div.classList.add("visually-hidden");
      document.body.appendChild(div);
    }
    window.flavorPickerInstance = new FlavorPicker(".flavor-picker-container");
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("flavor-picker:loaded"));
    }, 100);
  }
});
(function () {
  function handleFlavorUrlParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const flavorSku = urlParams.get("flavor");

    if (!flavorSku) return;

    const flavorItem =
      document.querySelector(
        `.flavor-item[data-sku="${flavorSku.toUpperCase()}"]`
      ) ||
      document.querySelector(`.flavor-item[data-sku="${flavorSku}"]`);

    if (!flavorItem) {
      console.warn(`[CYOP] Flavor not found for SKU: ${flavorSku}`);
      return;
    }

    if (window.flavorPickerInstance) {
      const picker = window.flavorPickerInstance;
      const currentQty = picker.getTotalQuantity();
      const maxSize = Math.max(...picker.pack.sizes);

      if (currentQty >= maxSize) {
        picker.resetPack();
      }

      picker.updateItemQuantity(flavorItem, 1);
      flavorItem.classList.add("flavor-preloaded");

      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("flavor");
      window.history.replaceState({}, "", cleanUrl.toString());
    }
  }

  document.addEventListener("flavor-picker:loaded", handleFlavorUrlParam);
})();